import { Controller } from "@hotwired/stimulus"

// Onglet Profil BEB (26/09/2026) : aperçu Google et WhatsApp en direct, et
// compteurs du titre (60) et de la description (160).
//
// Mêmes replis que le serveur (ProfilPublic) : titre vide → « <nom> sur
// Beb.tn », description vide → la phrase « Ce que vous faites », puis la
// phrase fabriquée avec les offres (valeur `repli`), image de partage
// absente → la photo. Si l'aperçu et la page divergeaient, le coach réglerait
// une page qu'il ne verra jamais.
export default class extends Controller {
  static targets = [
    "nom", "handle", "accroche", "titre", "description",
    "compteurTitre", "compteurDescription",
    "googleTitre", "googleDescription", "waTitre", "waDescription", "handleTexte",
    "photoFichier", "partageFichier", "photoImg", "photoInitiales", "waImage",
    "erreurs"
  ]
  static values = { repli: String }

  connect() {
    this.maj()
    // Après un envoi raté, le lecteur d'écran doit apprendre ce qui a échoué.
    if (this.hasErreursTarget) this.erreursTarget.focus()
  }

  maj() {
    const nom = this.valeur("nom")
    // Mêmes replis que le serveur (ProfilPublic#titre_google, SeoOffre.description_profil).
    const titre = this.valeur("titre") || (nom ? `${nom} sur Beb.tn` : "")
    const description = this.valeur("description") || this.valeur("accroche") || this.repliValue

    this.googleTitreTargets.concat(this.waTitreTargets).forEach(el => { el.textContent = titre })
    this.googleDescriptionTargets.concat(this.waDescriptionTargets).forEach(el => { el.textContent = description })
    if (this.hasHandleTarget) {
      const handle = this.handleTarget.value.trim() || "…"
      this.handleTexteTargets.forEach(el => { el.textContent = handle })
    }
    this.compter("titre", "compteurTitre", 60)
    this.compter("description", "compteurDescription", 160)
  }

  image(event) {
    const fichier = event.target.files && event.target.files[0]
    if (!fichier || !fichier.type.startsWith("image/")) return

    const lecteur = new FileReader()
    lecteur.onload = () => {
      const url = lecteur.result
      if (event.target === this.photoFichierTarget) {
        this.montrer(this.photoImgTarget, url)
        this.photoInitialesTarget.classList.add("hidden")
        this.waImageTarget.dataset.photo = url
      } else {
        this.waImageTarget.dataset.partage = url
      }
      const wa = this.waImageTarget.dataset.partage || this.waImageTarget.dataset.photo
      if (wa) this.montrer(this.waImageTarget, wa)
    }
    lecteur.readAsDataURL(fichier)
  }

  // ── outils ─────────────────────────────────────────────

  valeur(nom) {
    const cible = `has${nom[0].toUpperCase()}${nom.slice(1)}Target`
    return this[cible] ? this[`${nom}Target`].value.trim() : ""
  }

  compter(champ, compteur, max) {
    const cibleCompteur = `${compteur}Target`
    if (!this[`has${compteur[0].toUpperCase()}${compteur.slice(1)}Target`]) return

    const n = this.valeur(champ).length
    const el = this[cibleCompteur]
    const trop = n > max
    el.textContent = trop ? `Raccourcir à ${max} caractères` : `${n} / ${max}`
    el.classList.toggle("text-beb-danger-text", trop)
    el.classList.toggle("text-beb-fg-3", !trop)
  }

  montrer(img, url) {
    img.src = url
    img.classList.remove("hidden")
  }
}
